export const arrowUpGraph = [
  '0 0 32 32',
  `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_10816_11663)">
  <path d="M21.75 5.75L12.75 14.75L9 11L2.25 17.75" stroke="#49CE86" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21.75 11.75V5.75H15.75" stroke="#49CE86" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
  <clipPath id="clip0_10816_11663">
  <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
  </clipPath>
  </defs>
  </svg>
  `,
]
